<script>
export default {
    name: 'IconTwitter',
}
</script>
<template>
    <svg role="img"
        class="base-icon icon-twitter"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill="currentColor"
            fill-rule="evenodd"
            d="M54.244 20.464c.035.503.035 1.006.035 1.51C54.28 37.318 42.731 55 21.624 55A32.169 32.169 0 0 1 4 49.79c.924.107 1.812.143 2.772.143a22.822 22.822 0 0 0 14.248-4.96c-5.045-.107-9.274-3.45-10.73-8.05.71.108 1.42.18 2.167.18 1.03 0 2.06-.144 3.02-.395-5.259-1.078-9.203-5.75-9.203-11.392v-.144a11.46 11.46 0 0 0 5.188 1.473 11.635 11.635 0 0 1-5.117-9.667c0-2.156.569-4.133 1.564-5.858 5.65 7.044 14.142 11.644 23.665 12.147a13.247 13.247 0 0 1-.285-2.66C31.29 14.212 36.406 9 42.766 9a11.39 11.39 0 0 1 8.386 3.666 22.442 22.442 0 0 0 7.285-2.803 11.554 11.554 0 0 1-5.046 6.396c2.31-.251 4.548-.898 6.609-1.796a24.826 24.826 0 0 1-5.756 6.001z"
        />
    </svg>
</template>
